import React from 'react';
import GeckoFieldBase from '../_base.jsx';

const pixelStringToNumber = (pixelString) =>
  Number(pixelString.replace('px', ''));

const gotElementTotalVerticalBorder = (element) => {
  const computedStyles = window.getComputedStyle(element);
  const borderTop = pixelStringToNumber(computedStyles.borderTopWidth);
  const borderBottom = pixelStringToNumber(computedStyles.borderBottomWidth);
  return borderTop + borderBottom;
};

class GeckoFieldTextarea extends GeckoFieldBase {
  componentDidMount() {
    this.handleResize();
  }

  componentDidUpdate() {
    this.handleResize();
  }

  handleResize() {
    if (!this.props.field.autoResize || !this.textarea) {
      return;
    }
    this.textarea.style.height = '1px';
    const verticalBorder = gotElementTotalVerticalBorder(this.textarea);
    this.textarea.style.height =
      verticalBorder + this.textarea.scrollHeight + 'px';
  }

  render() {
    return (
      <textarea
        id={this.renderId()}
        ref={(elem) => (this.textarea = elem)}
        className="col-sm form-control gecko-ui-material"
        disabled={this.isDisabled()}
        value={this.value()}
        onChange={this.handleChange.bind(this)}
        rows={this.config().rows}
        placeholder={this.config().placeholder}
        onBlur={this.handleBlur.bind(this)}
      ></textarea>
    );
  }
}

export default GeckoFieldTextarea;
